import React from 'react';
import { Box, Slider, Typography } from '@mui/material';

export default function MobileSlider({ label, value, onChange, min, max, step, formatValue }) {
  const display = formatValue ? formatValue(value) : String(value);

  return (
    <Box sx={{ mb: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', mb: 1 }}>
        <Typography variant="body1" fontWeight={600}>
          {label}
        </Typography>
        <Typography variant="h2" color="primary.main" sx={{ fontSize: '1.25rem' }}>
          {display}
        </Typography>
      </Box>
      <Slider
        value={value}
        onChange={(_, v) => onChange(v)}
        min={min}
        max={max}
        step={step}
        color="secondary"
        aria-label={label}
      />
    </Box>
  );
}
